/**
 * Group options by optGroup, preserving the full type of options
 * @template {object} T - Type of option that has at least id, lib, and optGroup properties
 * @param {Array<T & {id: string, lib: string, optGroup?: string | null}>} options - Options to group
 * @returns {Array<{lib: string, options: Array<T>}>} Grouped options with preserved type
 */
const groupOptionsByOptGroup = (options) => {
  if (!options || options.length === 0) return [];

  const grouped = options.reduce((acc, option) => {
    const groupKey = option.optGroup || '';
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(option);
    return acc;
  }, /** @type {Record<string, Array<any>>} */ ({}));

  return Object.entries(grouped)
    .map(([lib, optionsArray]) => ({
      lib,
      options: optionsArray,
    }))
    .sort((a, b) => {
      // Put empty string optGroup first
      if (a.lib === '' && b.lib !== '') return -1;
      if (a.lib !== '' && b.lib === '') return 1;
      return 0;
    });
};

export default groupOptionsByOptGroup;
